import React from 'react';
import config from '../../../../config';

const Navbar = (props) => (
  <nav className='flex justify-start'>
    {shouldDisplay(props.role, 0) && (
      // eslint-disable-next-line
      <a
        className={
          props.tab === 0
            ? 'capitalize mr-8 text-lg font-medium tracking-wide text-primary no-underline border-b-4 border-primary hover:text-primary flex justify-center w-20 px-1'
            : 'capitalize mr-8 text-base font-normal tracking-wide no-underline border-b-2 border-transparent hover:text-primary leading-9 text-secondary'
        }
        set-key={0}
        onClick={props.handleChange}
      >
        {props.t('overview')}
      </a>
    )}
    {shouldDisplay(props.role, 1) && (
      // eslint-disable-next-line
      <a
        className={
          props.tab === 1
            ? 'capitalize mr-8 text-lg font-medium tracking-wide text-primary no-underline border-b-4 border-primary hover:text-primary flex justify-center px-1'
            : 'capitalize mr-8 text-base font-normal tracking-wide no-underline border-b-2 border-transparent hover:text-primary leading-9 text-secondary'
        }
        set-key={1}
        onClick={props.handleChange}
      >
        {props.t('activity')}
      </a>
    )}
    {shouldDisplay(props.role, 2) && (
      // eslint-disable-next-line
      <a
        className={
          props.tab === 2
            ? 'capitalize mr-8 text-lg font-medium tracking-wide text-primary no-underline border-b-4 border-primary hover:text-primary flex justify-center px-1'
            : 'capitalize mr-8 text-base font-normal tracking-wide no-underline border-b-2 border-transparent hover:text-primary leading-9 text-secondary'
        }
        set-key={2}
        onClick={props.handleChange}
      >
        {props.t('sleep')}
      </a>
    )}
    {shouldDisplay(props.role, 3) && (
      // eslint-disable-next-line
      <a
        className={
          props.tab === 3
            ? 'capitalize mr-8 text-lg font-medium tracking-wide text-primary no-underline border-b-4 border-primary hover:text-primary flex justify-center px-1'
            : 'capitalize mr-8 text-base font-normal tracking-wide no-underline border-b-2 border-transparent hover:text-primary leading-9 text-secondary'
        }
        set-key={3}
        onClick={props.handleChange}
      >
        {props.t('location')}
      </a>
    )}
    {shouldDisplay(props.role, 4) && (
      // eslint-disable-next-line
      <a
        className={
          props.tab === 4
            ? 'capitalize mr-8 text-lg font-medium tracking-wide text-primary no-underline border-b-4 border-primary hover:text-primary flex justify-center px-1'
            : 'capitalize mr-8 text-base font-normal tracking-wide no-underline border-b-2 border-transparent hover:text-primary leading-9 text-secondary'
        }
        set-key={4}
        onClick={props.handleChange}
      >
        {props.t('activity_details')}
      </a>
    )}
    {shouldDisplay(props.role, 5) && (
      // eslint-disable-next-line
      <a
        className={
          props.tab === 5
            ? 'capitalize mr-8 text-lg font-medium tracking-wide text-primary no-underline border-b-4 border-primary hover:text-primary flex justify-center'
            : 'capitalize mr-8 text-base font-normal tracking-wide no-underline border-b-2 border-transparent hover:text-primary leading-9 text-secondary'
        }
        set-key={5}
        onClick={props.handleChange}
      >
        {props.t('location_details')}
      </a>
    )}
    {shouldDisplay(props.role, 6) && (
      // eslint-disable-next-line
      <a
        className={
          props.tab === 6
            ? 'capitalize mr-8 text-lg font-semibold tracking-wide text-primary no-underline border-b-4 border-primary hover:text-primary flex justify-center px-1'
            : 'capitalize mr-8 text-base font-normal tracking-wide no-underline border-b-2 border-transparent hover:text-primary leading-9 text-secondary'
        }
        set-key={6}
        onClick={props.handleChange}
      >
        {props.t('device_usage')}
      </a>
    )}
    {shouldDisplay(props.role, 7) && (
      // eslint-disable-next-line
      <a
        className={
          props.tab === 7
            ? 'capitalize mr-8 text-lg font-medium tracking-wide text-primary no-underline border-b-4 border-primary hover:text-primary flex justify-center px-1'
            : 'capitalize mr-8 text-base font-normal tracking-wide no-underline border-b-2 border-transparent hover:text-primary leading-9 text-secondary'
        }
        set-key={7}
        onClick={props.handleChange}
      >
        {props.t('vitalsign')}
      </a>
    )}
    {shouldDisplay(props.role, 8) && (
      // eslint-disable-next-line
      <a
        className={
          props.tab === 8
            ? 'capitalize mr-8 text-lg font-medium tracking-wide text-primary no-underline border-b-4 border-primary hover:text-primary flex justify-center px-1'
            : 'capitalize mr-8 text-base font-normal tracking-wide no-underline border-b-2 border-transparent hover:text-primary leading-9 text-secondary'
        }
        set-key={8}
        onClick={props.handleChange}
      >
        {props.t('garmin_watch')}
      </a>
    )}
    {shouldDisplay(props.role, 9) && (
      // eslint-disable-next-line
      <a
        className={
          props.tab === 9
            ? 'capitalize mr-8 text-lg font-medium tracking-wide text-primary no-underline border-b-4 border-primary hover:text-primary flex justify-center px-1'
            : 'capitalize mr-8 text-base font-normal tracking-wide no-underline border-b-2 border-transparent hover:text-primary leading-9 text-secondary'
        }
        set-key={9}
        onClick={props.handleChange}
      >
        {props.t('patient_summary_menu_title')}
      </a>
    )}
  </nav>
);

const shouldDisplay = (role, tabId) => {
  const byRole = checkByRole(role, tabId);
  const byFeature = checkByFeature(tabId);
  return byRole && byFeature;
};

const checkByRole = (role, tabId) => {
  const roleLower = role.toLowerCase();
  const permissions = {
    admin: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    demo: [0, 7],
    caretaker: [0, 1, 2, 3, 4, 5, 7, 8],
    'home caretaker': [0, 1, 2, 3, 4, 5, 7, 8],
    'field hospital': [5, 6, 7],
    patient: [0, 1, 2, 7, 8],
  };

  const rolePermission = permissions[roleLower] ? permissions[roleLower] : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  return rolePermission.includes(tabId);
};

// const checkByFeature = (role, tabId) => {
//   let shouldDisplay = true;
//   switch (tabId) {
//     case 7:
//       shouldDisplay = config.features.report.vitalSign;
//       break;
//     case 8:
//       shouldDisplay = config.features.report.garmin;
//       break;
//   }

//   return shouldDisplay;
// };

const featureMapping = {
  7: () => config.features.report.vitalSign,
  8: () => config.features.report.garmin,
};

const checkByFeature = (tabId) => {
  const checkFeature = featureMapping[tabId];
  return checkFeature ? checkFeature() : true; // default to `true` if `tabId` is not in `featureMapping`
};
export default Navbar;
